import { useSelector } from 'hooks/utils';

export function useIsProjectValid() {
	return useSelector(state => state.data.projects.isValid);
}
